<template>
	<div id="contact">
		<div class="main">
        	<div class="small_nav">
        	    <router-link to='/'>首页 > </router-link><span>联系我们</span>
        	</div>
        	<div class="banner">
        		<img src="../assets/img/banner4.png"/>
        	</div>
        	<div class="dec">
        		<div class="item">
        			<h2>中旭御龙（深圳）租赁有限公司</h2>
        			<p>深圳市前海深港合作区南山街道桂湾五路56号前海卓越金融中心一期4栋05M-A</p>
        		</div>
        		<div id="map">
							<img src="../assets/img/map.png" alt="" class="map-img">
						</div>
        	</div>
        	<div class="compony">
		    	<p>中旭御龙（深圳）租赁有限公司</p>
				<p class="copy"><a href="http://beian.miit.gov.cn/" target="_blank">苏ICP备2023015410号</a></p>
		    </div>
        </div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				
			}
		},
		mounted(){
		}
	}
	
</script>

<style lang="scss">
	#contact{
		background:#F1F1F1;
		.main{
			width:1200px;
			margin:0 auto;
			padding-bottom:40px;
			background:#fff;
			
			.banner{
				width:1200px;
				img{
					display: block;
					width:100%;
				}
			}
			.dec{
				padding:45px 95px 35px;
				background:#fff;
				.item{
					h2{
						line-height:40px;
						font-size:26px;
						color:#333;
					}
					p{
						line-height:30px;
						font-size:16px;
						color:#757575;
						margin-bottom:20px;
					}					
				}
				
			}
			#map{
				width:1000px;
				.map-img{
					display: block;
					width:100%;
				}
			}
			.compony{
				line-height:45px;
				text-align: center;
				font-size:22px;
				color:#000000;
				opacity: 0.3;
				.copy{
					height:30px;
					line-height:30px;
					a{
						color:#000000;
						font-size:16px;
					}
				}
			}
		}
	}
</style>